import React, { useRef, useEffect } from 'react';
import { Form, Input } from '@ss/mtd-react';
import { useRootStore } from '@src/model';
import { observer } from 'mobx-react-lite';
import ModuleView from '../../ModuleView';
import './index.scss';

const FormItem = Form.Item;

// 仅社招
function SelfDescription(props) {
  const { data } = props;
  const formRef = useRef();
  const { socialResumeDetail, socialResumeFormRefStore } = useRootStore();

  const store = socialResumeDetail;
  const storeRef = socialResumeFormRefStore;

  useEffect(() => {
    storeRef.changeRef('descriptionRef', formRef.current);
    // @ts-ignores
    formRef?.current?.setAllFieldsValue?.({ description: data });
  }, [data]);

  const handleValueChange = (formItemKey: string, formItemValue: any) => {
    store.setDescription(formItemKey, formItemValue);
  };

  return (
    <div className="self_description_edit model_edit">
      <div className="model_title">自我描述</div>
      <div className="model_list_description">
        <Form
          // @ts-ignore
          ref={formRef}
          defaultFieldsValue={{ description: data }}
          className="modal_form"
          onFieldValueChange={(formItemKey, formItemValue) => handleValueChange(formItemKey, formItemValue)}
        >
          <FormItem formItemKey="description" labelWidth={0}>
            <Input.TextArea
              className="input_text_area"
              toFormItem
              placeholder="请填写自我描述"
              maxLength={2000}
              autosize={{ minRows: 3, maxRows: 6 }}
              showCount
            />
          </FormItem>
        </Form>
      </div>
    </div>
  );
}

export default ModuleView(observer(SelfDescription), 'SelfDescription');
